import React, { Fragment } from "react";

import { Modal } from "antd";

import "@/styles/components/sweet-popup.scss";

const SweetPopup = ({
  title = null,
  centered = true,
  keyboard = false,
  mask = true,
  maskClosable = true,
  closeIcon = false,
  footer = null,
  width = 311,
  className = "",
  children,
  isOpen = false,
  isDone = false,
  isConfirm = false,
  isReport = false,
  message = "Success",
  otherMessage = "You can check now...",
  onCancelClick = () => {},
  ...rest
}) => {
  return (
    <Fragment>
      <Modal
        title={title}
        centered={centered}
        keyboard={keyboard}
        mask={mask}
        maskClosable={maskClosable}
        closeIcon={closeIcon}
        footer={footer}
        width={width}
        className={className}
        open={isOpen}
        {...rest}
      >
        {isDone && (
          <div className="success-icon">
            <div className="icon">
              <img src="/assets/images/done.svg" alt="" />
            </div>
          </div>
        )}

        {isReport && (
          <div className="report-icon">
            <div className="icon">
              <img src="/assets/images/report.svg" alt="" />
            </div>
          </div>
        )}

        {isConfirm && (
          <div className="confirm-icon">
            <div className="icon">
              <img src="/assets/images/confirm.svg" alt="" />
            </div>
          </div>
        )}

        <div className="success-message body-b1">{message}</div>

        <div className="success-other-message body-b4">{otherMessage}</div>

        {children}
      </Modal>
    </Fragment>
  );
};

export default SweetPopup;
